import type { MarkElementProps } from "@mui/x-charts"

export const FilledCircleMark = (props: MarkElementProps) => {
  const { x, y, color, isHighlighted } = props
  const r = isHighlighted ? 5 : 2.5
  return <circle cx={x} cy={y} r={r} fill={color} />
}
